import React from 'react'

import { hooks } from '@front/volcanion'

const withContainer = Component => props => {
  const [{ record_id, isManagingRecord }] = hooks.useFormState()
  const enableSubmitAll = !!isManagingRecord

  const mergedProps = {
    record_id,
    enableSubmitAll
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
